import { createContext } from '@lit/context';
export const SwapContextToken = createContext(Symbol('SwapContextToken'));
//# sourceMappingURL=swap-context-token.js.map